import { styled } from '@mui/material/styles'
import { Box, Card, Chip, Typography, TextField, Table, TableContainer, Button } from '@mui/material'
import { Link } from 'react-router-dom'
import { GridToolbarQuickFilter } from '@mui/x-data-grid-pro'

export const gridStyles = theme => ({
  width: '100%',
  backgroundColor: theme.palette.mode === 'dark' ? '' : 'rgb(232, 246, 252)',
  color: '#fff',
  minHeight: '50vh',
  maxHeight: '95vh',
  padding: '20px',
  '& .MuiDialogContent-root': {
    width: '100%',
    padding: '20px',
  },
  '& .MuiTextField-root': {
    margin: '10px 0',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        // This targets the border of the TextField
        border: theme.palette.mode === 'dark' ? '' : '1px solid', // Removes the border
        borderColor: theme.palette.mode === 'dark' ? '' : 'rgba(0,0,0,0.1)',
      },
      '&:hover fieldset': {
        border: theme.palette.mode === 'dark' ? '' : '1px solid', // Removes the border
        borderColor: theme.palette.mode === 'dark' ? '' : 'rgba(0,0,0,1)',
      },
      '&.Mui-focused fieldset': {
        border: 'none', // Removes the border when the TextField is focused
      },
      '&.Mui-focused fieldset': {
        border: '2px solid rgb(159, 176, 219)', // Changes border when focused
        // backgroundColor: '#e3f2fd', // Changes background when focused
      },
    },
  },
  '& .MuiInputBase-root': {
    height: '45px',
    backgroundColor: theme.palette.mode === 'dark' ? 'rgb(22, 28, 42)' : 'rgba(255,255,255,1)',
  },
  '& input[type="number"]': {
    // Hides the up and down arrows on webkit browsers like Chrome, Safari, and Edge
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    // Hides the up and down arrows on Firefox
    '&[type=number]': {
      MozAppearance: 'textfield',
    },
  },
})

export const OrganizationsCard = styled(Card)(({ theme, type }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(30 43 59)' : 'rgb(255, 255, 255)',
  textAlign: 'left',
  borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0,0,0,0.12)', // Dim white borde
  borderWidth: '1px',
  borderStyle: 'solid',
  fontWeight: 'bold',
  //   minWidth: '100px', // Set a consistent width for the Chip
  //   maxWidth: '1000px', // Set a consistent width for the Chip
  //   minHeight: '70px',
  borderRadius: '4px',
  '&:hover': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.32)' : 'rgba(0,0,0,0.22)',
  },
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
}))

export const OrgDetailsBox = styled(Box)(({ theme, type }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(30 43 59)' : 'rgb(255, 255, 255)',
  textAlign: 'left',
  borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0,0,0,0.12)', // Dim white borde
  borderWidth: '1px',
  borderStyle: 'solid',
  fontWeight: 'bold',
  //   minWidth: '100px', // Set a consistent width for the Chip
  //   maxWidth: '500px', // Set a consistent width for the Chip
  //   minHeight: '70px',
  borderRadius: '4px',
  '&:hover': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.32)' : 'rgba(0,0,0,0.22)',
  },
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
}))
export const CompanyLabelChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(30 43 59)' : '#ffffff',
  textAlign: 'left',
  borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0,0,0,0.12)', // Dim white borde
  borderWidth: '1px',
  borderStyle: 'solid',
  fontWeight: 'bold',
  // minWidth: '60px', // Set a consistent width for the Chip
  // maxWidth: '30px', // Set a consistent width for the Chip
  // minHeight: '30px',
  height: '20px',
  width: '60px',
  borderRadius: '4px',
  '&:hover': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.32)' : 'rgba(0,0,0,0.22)',
  },
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
}))
export const dialogStyles = theme => ({
  width: '100%',
  maxWidth: '800px',
  backgroundColor: theme.palette.mode === 'dark' ? '' : 'rgb(232, 246, 252)',
  color: '#fff',
  minHeight: '50vh',
  maxHeight: '95vh',
  padding: '20px',
  '& .MuiDialogContent-root': {
    width: '100%',
    padding: '20px',
  },
  '& .MuiTextField-root': {
    margin: '10px 0',
    flex: '1 1 45%', // Allows text fields to be 45% of the container width
    minWidth: '150px', // Ensures a minimum width for text fields
  },
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgb(67, 70, 75)' : 'white',
    minWidth: '150px', // Ensures a minimum width for input base
    flex: '1 1 45%', // Allows select components to be 45% of the container width
  },
  '& .MuiSelect-root': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgb(67, 70, 75)' : 'white',
    flex: '1 1 45%', // Allows select components to be 45% of the container width
    minWidth: '150px', // Ensures a minimum width for select components
  },
})

export const dialogContentStyles = {
  width: 'auto',
  maxWidth: '700px',
  margin: '0 auto',
}
export const InfoBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(30, 39, 53)' : '#f4f6f8',
  padding: theme.spacing(6),
  borderRadius: '25px',
}))
export const CustomInfoBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(30, 39, 53)' : '#f4f6f8',
  padding: theme.spacing(0),
  borderRadius: '25px',
}))
export const InfoBoxContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(30, 39, 53)' : 'rgb(255, 255, 255)',
  padding: theme.spacing(3),
  borderRadius: '25px',
}))

export const InfoRow = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  position: 'relative',
}))

export const InfoLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 500,
  fontSize: '0.875rem',
  marginBottom: theme.spacing(0.5),
}))

export const InfoValueWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
}))

export const InfoValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  fontSize: '1rem',
}))

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? '#90caf9' : '#1976d2',
  fontWeight: 700,
  fontSize: '1rem',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}))

export const Underline = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '1px',
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
}))

export const CityStateZipRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2),
  position: 'relative',
}))
export const DualRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2),
  position: 'relative',
}))
export const PhoneRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2),
  position: 'relative',
}))
export const OrganizationTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(30 43 59)' : '#ffffff',
  textAlign: 'left',
  borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0,0,0,0.12)', // Dim white borde
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '4px',

  '&:hover': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.32)' : 'rgba(0,0,0,0.22)',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.12)', // Dim white border
    },
    '&:hover fieldset': {
      borderWidth: '0px !important',
    },
    '&.Mui-focused fieldset': {
      borderWidth: '1px !important',
      borderColor: theme.palette.mode === 'dark' ? 'white' : 'black',
      // backgroundColor: theme.palette.mode === 'dark' ? 'red' : '#f0f0f0', // Change background color when focused
      // borderColor: 'white', // Change border color when focused
    },
  },
  '& .MuiOutlinedInput-root.Mui-focused': {
    // backgroundColor: theme.palette.mode === 'dark' ? 'red' : '#f0f0f0', // Change background color when focused
  },
  '& .MuiOutlinedInput-input': {
    '&:focus': {
      backgroundColor: theme.palette.mode === 'dark' ? 'rgb(40 53 69)' : '#f0f0f0', // Ensure the input itself also changes background color
    },
  },
}))
export const gridContainerStyles = {
  display: 'flex',
  maxHeight: '100vh',
  // width: '100%',
  justifyContent: 'center',
  // alignItems: 'center',
}
export const SaveButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'rgb(42, 128, 200)',
}))
export const EditButton = styled(Button)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? 'rgba(0,0,0,1)' : 'rgba(0,0,0, 1)',
  fontWeight: 'bold',
  backgroundColor: 'rgb(251, 192, 147)',
  '&:hover': {
    color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,1)' : '',
    // fontWeight: 'bold',
    // backgroundColor: 'rgba(0,0,0, 0.5)',
  },
}))
export const CreateButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'rgb(29, 106, 82)',
}))
export const detailTextStyle = theme => ({
  fontWeight: 'bold',
  fontSize: 16,
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
})
export const detailHeaderStyle = theme => ({
  // fontWeight: 'bold',
  fontSize: 20,
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
})
export const detailNameStyle = theme => ({
  fontWeight: '800',
  fontSize: 22,
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
})

export const headerStyle = theme => ({
  fontWeight: 'bold',
  fontSize: 24,
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
})
export const HeaderButton = styled(Button)(({ theme }) => ({
  // backgroundColor: theme.palette.mode === 'dark' ? 'rgb(51, 67, 91)' : 'rgb(211, 211, 211)',
  backgroundColor: 'rgb(29, 106, 82)',
  color: theme.palette.mode === 'dark' ? 'white' : 'white',
}))
export const orgTextStyle = theme => ({
  fontWeight: 'bold',
  fontSize: 16,
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
})
export const popoverStyles = theme => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(30, 39, 53, 0.85)' : 'rgba(255, 255, 255, 0.85)',
  zIndex: 1000,
})

export const boxContainerStyles = theme => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: theme.spacing(2),
})

export const boxStyles = theme => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left',
  width: '100%',
  border: '1px solid',
  borderColor: 'rgba(201, 50, 46, 0.5)',
  padding: theme.spacing(1),
})
export const accountBoxStyles = theme => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left',
  width: '100%',
  border: '1px solid',
  borderColor: 'rgb(251, 193, 30)',
  padding: theme.spacing(1),
})

export const deleteButtonStyles = theme => ({
  borderColor: 'black',
  color: 'red',
  fontWeight: 'bold',
  ':hover': {
    backgroundColor: 'rgba(201, 50, 46)',
    borderColor: 'black',
    color: theme.palette.mode === 'dark' ? 'white' : 'black',
  },
})
export const deleteIconStyles = theme => ({
  borderColor: 'black',
  fontSize: 30,
  color: 'red',
  fontWeight: 'bold',
  ':hover': {
    backgroundColor: 'rgba(201, 50, 46)',
    borderColor: 'black',
    borderRadius: '24px',
    color: theme.palette.mode === 'dark' ? 'white' : 'black',
  },
})

export const textStyles = theme => ({
  width: '100%',
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
  padding: theme.spacing(1),
  fontSize: 18,
})

export const buttonContainerStyles = theme => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  marginTop: theme.spacing(2),
  gap: theme.spacing(1),
})

export const overlayTextStyles = theme => ({
  position: 'absolute',
  top: '-700px', // Adjust the value to position the text above the box
  left: '50%',
  transform: 'translateX(-50%)',
  color: 'rgba(255, 0, 0, 0.8)', // Adjust for better visibility
  fontSize: 22,
  fontStyle: 'italic',
  fontWeight: 'bolder',
  zIndex: 1001,
  textAlign: 'center',
  width: '80%',
  pointerEvents: 'none',
})
export const stringAvatar = (name = '', fontsize) => {
  // Check if name is undefined or an empty string
  const nameParts = name ? name.split(' ') : ['']

  if (nameParts.length < 2) {
    return {
      children: (
        <Typography
          sx={{
            fontSize: fontsize ? fontsize : 14,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          {nameParts[0][0] || ''} {/* Handle the case where nameParts[0][0] is undefined */}
        </Typography>
      ),
    }
  }

  return {
    children: (
      <Typography
        sx={{
          fontSize: fontsize ? fontsize : 14,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        {`${nameParts[0][0]}${nameParts[1][0]}`}
      </Typography>
    ),
  }
}

export const gridToolbarContainerStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}
export const StyledGridToolbarQuickFilter = styled(GridToolbarQuickFilter)(({ theme }) => ({
  '&.MuiFormControl-root': {
    // This applies the styles to the root element of the quick filter
    // backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
    border: '1px solid',
    borderColor: 'transparent',
    padding: '5px',
    // borderRadius: '4px',
    transition: 'border-color 0.5s ease',

    // Add a subtle focus effect
    '&:focus-within': {
      border: '1px solid',
      borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)',
    },
  },
  '@keyframes fadeOut': {
    '0%': {
      border: '1px solid',
      borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.4)',
    },
    '100%': {
      borderColor: 'transparent',
    },
  },
  '& .MuiInputBase-root': {
    paddingLeft: '8px', // Adjust padding or any other desired style here
  },
}))

export const filterPanelProps = {
  '& .MuiDataGrid-filterForm': {
    width: '100%',
    // padding: '10px',
    borderRadius: '8px',
    display: 'flex', // Make the form a flex container
    alignItems: 'center', // Vertically align items in the center
    gap: '16px', // Add space between each form element
    '& .MuiFormControl-root': {
      flex: '1 1 auto',
      margin: '0',
      minWidth: '100px',
      '& .MuiInputBase-root': {
        padding: '4px', // Adjust padding for input fields
        borderRadius: '4px',
      },
    },
  },
  '& .MuiDataGrid-filterFormValueInput': {
    flex: '2 1 auto', // Allow the value input more space
    minWidth: '150px', // Minimum width for input
    '& input': {
      padding: '6px 8px', // Adjust padding for the input field
      width: '100%',
    },
  },
  '& .MuiSvgIcon-root': {
    fontSize: '18px', // Decrease the size of the 'x' icon
  },
}

export const ApprovalTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: 20, // Increase the margin top to ensure the top border is visible
  padding: '10px', // Add padding to create space inside the container
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgb(232, 246, 252)',
}))
export const ApprovalTable = styled(Table)(({ theme }) => ({
  marginTop: 5, // Increase the margin top to ensure the top border is visible
  padding: '5px', // Add padding to create space inside the container
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgb(232, 246, 252)',
}))

export const tableCellStyles = (theme, color, item) => ({
  fontWeight: 'bold',
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(22, 28, 42)' : 'rgba(255, 255, 255, 1)',
  color: color ? color : theme.palette.mode === 'dark' ? 'rgba(255,255,255,1)' : 'rgba(0,0,0,1)',
  border: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 0.4)' : '1px solid rgba(0,0,0,0.4)',
  textAlign: 'left',
})
export const tableRowStyles = theme => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(30, 39, 53)' : 'rgba(255,255,255,1)',
  // border: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 0.4)' : '1px solid rgba(0,0,0,0.4)',
})
export const tableHeaderStyles = theme => ({
  fontWeight: 'bold',
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgba(232, 240, 254)', // light gray with hint of blue
  textAlign: 'left',
  color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
  border: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 0.4)' : '1px solid rgba(0,0,0,0.4)',
})
export const tableSectionStyles = theme => ({
  fontWeight: 'bold',
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgb(232, 246, 252)', // lighter gray
  color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,1)' : 'rgba(0,0,0,1)',
  // border: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 0.4)' : '1px solid rgba(0,0,0,0.4)',
})
export const tableKeyStyles = theme => ({
  fontWeight: 'bold',
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(22, 28, 42)' : 'rgba(255, 255, 255, 1)',
  color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
  // border: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 0.4)' : '1px solid rgba(0,0,0,1)',
  textAlign: 'left',
})
export const infoTableContainerStyles = theme => ({
  fontWeight: 'bold',
  textAlign: 'left',
  color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
  // border: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 0.4)' : '1px solid rgba(0,0,0,0.4)',
  // bgcolor: theme.palette.background.paper,
})
export const infoTableHeaderStyles = theme => ({
  color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
})
export const infoTableTextStyles = theme => ({
  color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,1)' : 'rgba(0,0,0,1)',
})
// backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgba(0, 0, 0, 0.2)',
// backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgba(250, 212, 212)', // light coral
// backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgba(243, 229, 245)', // pale lavender
// backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgba(245, 245, 220)', // warm beige
// backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgba(230, 249, 232)', // pastel green
// backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgba(224, 247, 250)', // muted aqua
// backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgba(232, 240, 254)', // light gray with hint of blue
// backgroundColor: theme.palette.mode === 'dark' ? 'rgb(26, 22, 22)' : 'rgba(221, 238, 255)', // soft blue
